import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CMSManagementLayer from "../components/CMSManagement/CMSManagementLayer";

const CMSManagementPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="CMS Management" />
      <CMSManagementLayer />
    </MasterLayout>
  );
};

export default CMSManagementPage;
